<template>
  <v-card class="overflow-hidden" color="#F9F6F6">
    <v-app-bar class="header pt-2" color="white">
      <v-row class="ma-0 mt-4">
        <v-spacer/>
        <img
          @click="toggleDepartment('peach', selected_influencer ? '/roster' : undefined)"
          :class="{ 'is-disabled': selected_department === 'plum' }"
          class="mr-4 logo"
          src="/LogoPEACH.png"
        />
        <img
          @click="toggleDepartment('plum', selected_influencer ? '/roster' : undefined)"
          :class="{ 'is-disabled': selected_department === 'peach' }"
          class="ml-4 logo"
          src="/PLUMAGENCY.png"
        />
        <v-spacer/>
      </v-row>
    </v-app-bar>
    
    <influencer :selected_influencer="selected_influencer" v-if="selected_influencer!=undefined"/>
    <home :selected_department="selected_department" v-else/>
  </v-card>
</template>

<script>
import Home from './Home.vue'
import Influencer from './Influencer.vue'
export default {
    components:{
        'home':Home,
        'influencer':Influencer
    },
    data(){
        return{
            selected_department:''
        }
    },
    computed:{
        selected_influencer(){
            return this.$route.query.influencer_id
        }
    },
    methods: {
      toggleDepartment(dep, router) {
        if(router){
          if(!this.selected_department || this.selected_department!=dep){
            this.selected_department = this.selected_department === dep ? '' : dep
          }
          this.$router.push('/roster')
        }else{
          this.selected_department = this.selected_department === dep ? '' : dep
        }
      }
    }
}
</script>

<style>
.v-application .header {
  box-shadow: 0px 5px 10px -3px rgba(0,0,0,.1) !important;
  height: 91.5px !important;
  position: fixed;
  z-index: 200;
}
.roster-container{
    padding-top:110px!important;
}
.is-disabled { opacity: .5; }
.logo{
  cursor:pointer; 
  max-height:50px!important; 
  height:50px!important; 
  width:auto!important;
}
</style>
